import { render, staticRenderFns } from "./SysTableColumn.vue?vue&type=template&id=36d86947&scoped=true"
import script from "./SysTableColumn.vue?vue&type=script&lang=js"
export * from "./SysTableColumn.vue?vue&type=script&lang=js"
import style0 from "./SysTableColumn.vue?vue&type=style&index=0&id=36d86947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d86947",
  null
  
)

export default component.exports